const leftTemplate = {};

leftTemplate.imageSection = (element) => {
  console.log('leftTemplate.imageSection');
  console.log(element);
  const productImage = element.querySelector(
    '.configurator__section__fields__subsection--main-model__control--image-wrapper img',
  )
    ? element.querySelector(
        '.configurator__section__fields__subsection--main-model__control--image-wrapper img',
      )
    : null;
  const productImageSrc = productImage ? productImage.src : '';
  const productImageAlt = productImage ? productImage.alt : '';

  return `
    <div class="configurator__section">
        <div class="configurator__section--3cols configurator__section--main-model clearfix" >
            <div id="configurator__section--main-model__placeholder">
                <section class="configurator__section__fields__subsection configurator__section__fields__subsection--main-model configurator__section__fields__subsection--image">
                    <div class="configurator__section__fields__subsection--main-model__control--image">
                        <div class="configurator__section__fields__subsection--main-model__control--image-wrapper">
                            <img src="${productImageSrc}" alt="${productImageAlt}">
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
    `;
};

/* eslint-disable-next-line */
leftTemplate.summarySection = (element) => {
  // TODO
  return ``;
};

/* eslint-disable-next-line */
leftTemplate.ctaSection = (element) => {
  // TODO
  return `
    <div class="cta_controller__start">
        <!-- New: Replace with dynamic content -->
        <p class="product_name" runat="server" id="CTAProductName">Linx Quattro Premium Mini Receiver</p>
        <ul class="product_features">
            <li>Feature</li>
        </ul>
        <!-- Replace: END -->
    </div>
    <div class="cta_controller__end">
        <div class="is-last">
            <!-- New / modified -->
            <button class="btn btn-primary" id="btnLauchModal">Add to cart</button>
        </div>
    </div>
    `;
};

export default leftTemplate;
